import React, { useEffect, useState } from 'react';
import Header from '../../../layout/Header';
import Subheader from '../../../layout/Subheader';
import Loading from '../../../components/Loading';
import TableContent from './TableContent';
import OperationsMiddle from './OperationsMiddle';
import * as S from './styles';

export function TimeCardReport() {
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState();
  const [totais, setTotais] = useState();
  const [permiteEdicao, setPermiteEdicao] = useState(false);
  const [colaboradorId, setColaboradorId] = useState(0);
  const [reloadData, setReloadData] = useState(false);

  return (
    <S.Root>
      <Header />
      <Subheader title={'Relatório de Pontos'} back="/app/home" />

      <S.Content style={{ display: 'flex' }}>
        <div
          style={{
            width: '100%',
            margin: '30px 30px',
            padding: '0px 20px 20px 20px',
            height: '100%',
            border: '2px solid #ddd',
            borderRadius: '8px',
            backgroundColor: '#eee',
          }}
        >
          <OperationsMiddle
            setTableData={setTableData}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            setTotais={setTotais}
            setPermiteEdicao={setPermiteEdicao}
            setColaboradorId={setColaboradorId}
            reloadData={reloadData}
            setReloadData={setReloadData}
          />
        </div>
      </S.Content>
      {isLoading ? (
        <Loading />
      ) : (
        <div>
          <TableContent
            tableData={tableData}
            totais={totais}
            permiteEdicao={permiteEdicao}
            colaboradorId={colaboradorId}
            setReloadData={setReloadData}
          />
        </div>
      )}
    </S.Root>
  );
}
